/* 
  Pollyfills
*/
import '@babel/polyfill'
import './lib/requestIdleCallback'

// Modules
import Site from './site'

Site.startWidgets()
